import { Box, Typography , IconButton, Drawer, Skeleton, Grid} from "@mui/material"
import { ArrowLeft } from "../../../../../../core/global/Icons"
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';

export const FileInfo =({ v,handleOpenMember, open, onClose , allUsers, isLoading})=>{
    if (!v) return null;
    
    return(
        <Drawer anchor="right" open={open} onClose={onClose} variant="persistent" PaperProps={{sx: {width:'100vw'}}} hideBackdrop>
            <Box  height='100%' width="100%" bgcolor="#FFFFFF" display="flex" flexDirection="column" >
                <Box minHeight="44px" p="12px 16px" display="flex" alignItems="center" justifyContent='space-between'>
                    <Box>
                        <IconButton sx={{p: '0px'}} onClick={onClose}>
                            <ArrowLeft stroke="#313131" width={16} height={16} />
                        </IconButton>
                    </Box>
                </Box>
                    <Box>
                        <Typography fontSize="16px" fontWeight={600} lineHeight="26px" p="10px 0px 0px 10px">Team Details</Typography>
                        <Grid container>
                            <Box display="flex" flexDirection="row" px={2} py={1} width="100%">
                                <Grid item xs={6}><Typography fontSize="14px" fontWeight={500} color="#737373" >Team Number:</Typography></Grid>
                                <Grid item xs={6}>
                                    { isLoading ?
                                        (<Skeleton variant="rectangle" width="50%" />)
                                        :
                                        (<Typography fontWeight={500} fontSize="14px">{v.team_number}</Typography>)
                                    }
                                </Grid>
                            </Box>
                            <Box  display="flex" flexDirection="row" px={2} py={1} width="100%">
                                <Grid item xs={6}><Typography fontSize="14px" fontWeight={500} color="#737373" >Team Name:</Typography></Grid>
                                <Grid item xs={6}>
                                    { isLoading ?
                                        (<Skeleton variant="rectangle" width="50%"/>) 
                                        : 
                                        (<Typography fontWeight={500} fontSize="14px">{v.name}</Typography>)
                                    }
                                </Grid>
                            </Box>
                                
                            <Box  display="flex" flexDirection="row" px={2} py={1} width="100%">
                                <Grid item xs={6}><Typography fontSize="14px" fontWeight={500} color="#737373" >Team Member:</Typography></Grid>
                                <Grid item xs={6}>
                                    { isLoading ?
                                        (<Skeleton variant="rectangle" width="50%"/>) 
                                        :  
                                        (<Box  sx={{ fontSize:'14px', justifyItems:'left'}}  onClick={(e) => handleOpenMember (e, v)}>
                                        <AvatarGroup max={3} spacing={5} sx={{'& .MuiAvatar-root': { width: 20, height: 20, fontSize: 12, },}}>
                                                {allUsers?.filter(user => v.member?.includes(user.id)).map(user => (
                                                    <Avatar
                                                        key={user.id}
                                                        alt={user.uname}
                                                        src={user.profile}>
                                                        {!user.profile && user.uname?.[0]}
                                                        {/* {user.profile} */}
                                                    </Avatar>
                                                ))}
                                        </AvatarGroup>
                                    </Box> )
                                    }
                                </Grid>
                            </Box>  
                                
                            <Box  display="flex" flexDirection="row" px={2} py={1} width="100%">
                                <Grid item xs={6}><Typography fontSize="14px" fontWeight={500} color="#737373"  >Status:</Typography></Grid>
                                <Grid item xs={6}>
                                        { isLoading ?
                                            (<Skeleton variant="rectangle" width="50%"/>)
                                            :
                                            (<Box fontSize="14px" sx={{height:'auto', fontSize:'12px',textAlign:'center' ,width:'50px'}}   bgcolor={v.active === 1 ? '#00be811f' : '#E4E5E6'} color={v.active === 1 ? '#00be81' : '#7B7F82'} borderRadius="16px" px={1}>
                                            <Box>{v.active === 1 ? 'Active' : 'Inactive'}</Box>
                                        </Box>)
                                        }
                                </Grid>
                            </Box>
                        </Grid>
                    </Box>
                </Box>   
        </Drawer>
    )
}